import { Icon, RowFlexDiv, ColumnFlexDiv } from "../CommonStyle";
import { NudistaBold18, NudistaSemiBold12 } from "../Fonts";

const week = [
  {
    day: "SUN",
    date: "01",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
  {
    day: "MON",
    date: "02",
    weather: "/images/mainView/assignmentsView/sun.svg",
  },
  {
    day: "TUE",
    date: "03",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
  {
    day: "WED",
    date: "04",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
  {
    day: "THU",
    date: "05",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
  {
    day: "FRI",
    date: "06",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
  {
    day: "SAT",
    date: "07",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
  {
    day: "SUN",
    date: "01",
    weather: "/images/mainView/assignmentsView/weather-1.svg",
  },
];

const DateCarousel = () => {
  return (
    <RowFlexDiv width="100%" gap="10px">
      {week.map((weather) => {
        return (
          <RowFlexDiv
            key={weather.id}
            width="12%"
            padding="4px 12px"
            justifyContent="flex-start"
            border="1px solid rgba(106,38,202, 0.2)"
            backgroundColor={weather.day === "MON" ? "#6503EF" : ""}
          >
            <Icon src={weather.weather} />
            <ColumnFlexDiv justifyContent="center" alignItems="center">
              <NudistaSemiBold12
                color={weather.day === "MON" ? "whiteColor" : "primary"}
              >
                {weather.day}
              </NudistaSemiBold12>
              <NudistaBold18
                color={weather.day === "MON" ? "whiteColor" : "primary"}
              >
                {weather.date}
              </NudistaBold18>
            </ColumnFlexDiv>
          </RowFlexDiv>
        );
      })}
    </RowFlexDiv>
  );
};

export default DateCarousel;
